import { render, staticRenderFns } from "./teilnehmer-hint-pills.vue?vue&type=template&id=274bb7a2&scoped=true"
import script from "./teilnehmer-hint-pills.vue?vue&type=script&lang=js"
export * from "./teilnehmer-hint-pills.vue?vue&type=script&lang=js"
import style0 from "./teilnehmer-hint-pills.vue?vue&type=style&index=0&id=274bb7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bb7a2",
  null
  
)

export default component.exports